const riot = require('riot');

riot.tag2('module-section-header', '<div class="f ft fbw"> <div> <div class="ts-hm text-navy">{opts.title}</div> <div class="ts-pxs text-gray_60 mt16" if="{opts.description}">{opts.description}</div> </div> <yield from="right"></yield> </div>', '', '', function(opts) {
});